module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/caret-794bd7608e3ca866e526752e884d6f13.svg";